import { variables as configVarsLocal } from './configLocal';
import { variables as configVarsQa } from './configQa';
import { variables as configVarsProd } from './configProd'


export const configVariables = (word) => {
    return configVarsProd[word]
    const hostname = window.location.host
    if(hostname.includes("sabordecasa.com"))
        return configVarsProd[word]
    else
        return configVarsQa[word]
}